/*
 * Action Types
 */
export enum RouteTypes {
  SET_ROUTE_ACTIVE = '@route/SET_ROUTE_ACTIVE',
}

/*
 * State type
 */
export interface RouteState {
  readonly routeActive: string;
}
